import type { LifecycleState } from '@/models/lifecycleState';

export type ItemRarity =
  | 'common'
  | 'uncommon'
  | 'rare'
  | 'epic'
  | 'legendary'
  | 'mythic'
  | '';

export const itemTypes = ['item', 'bundle', 'season_pass', 'currency'] as const;
export type ItemType = (typeof itemTypes)[number];

// Per-language translation attached to an item only when `GET /v1/items` is
// called with `languages`. The API returns more fields (id, item_code, …) but
// the UI only reads name/description.
export interface ItemTranslationFields {
  name: string;
  description: string;
}

// For API responses - includes full nested item
export interface BundleItemResponse {
  quantity: number;
  item: Item; // Properly typed - full Item object at runtime
}

// For API requests - only code and quantity needed
export interface BundleItemRequest {
  item_code: string;
  quantity: number;
}

// For form state - hybrid (can have either)
export interface BundleItemForm {
  code: string;
  quantity: number;
  item?: Item; // Optional - present when loaded from API (full Item object)
  name?: string; // Optional - for temporary display before API loads
}

export interface Item {
  id: string;
  item_id: string;
  code: string;
  name: string;
  type: ItemType;
  unique: boolean;
  stackable: boolean;
  consumable: boolean;
  sandbox_code: string;
  game_code: string;
  item_rarity?: ItemRarity;
  limit?: number;
  currency_code?: string;
  metadata?: Record<string, string>;
  bundle_items?: BundleItemResponse[]; // API returns full nested items
  state?: LifecycleState;
  platform_mappings?: Record<string, string>;
  // Keyed by language tag; present only when fetched with `languages`.
  translations?: Record<string, ItemTranslationFields>;
}
